/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 11/07/2024 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

import react, { useEffect } from 'react'
import { grid, typography } from '@mui/material';

export default function frmventasdetalles() {
   useEffect(() => {
       window.scrollTo(0, 0);
    },[]);

    return(<></>)
}